import PropTypes from 'prop-types';
import { ThemeProvider } from '@bevy/bevy-design-system';
import SepiidaStylesheet from '@bevy/bevy-design-system/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { useLanguageLoader } from '~/utils/language';
import ReactErrorBoundary from '@/shared/features/ReactErrorBoundary';
import { appQueryDefaults } from '~/store/queryClients';
import { dashboardTheme } from '~/styles/theme/dashboardTheme';
import styles from '~/styles/app.module.less';
import 'react-toastify/dist/ReactToastify.css';

import { ENVIRONMENT } from '~/constants/index';

export const AppQueryClient = new QueryClient(appQueryDefaults);

const Providers = ({ children }) => {
  const isLoaded = useLanguageLoader();
  if (!isLoaded) return null;
  return (
    <div role='application' className={styles.app}>
      <ReactErrorBoundary environment={ENVIRONMENT}>
        <SepiidaStylesheet />
        <QueryClientProvider client={AppQueryClient}>
          <ThemeProvider theme={dashboardTheme}>
            <ThemeProvider namespace='dashboard' theme={dashboardTheme}>
              <div className={styles.dashboardApp}>{children}</div>
              {/* {ENVIRONMENT === 'development' && <ReactQueryDevtools initialIsOpen={false} />} */}
              <ToastContainer theme='dark' />
            </ThemeProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </ReactErrorBoundary>
    </div>
  );
};

Providers.propTypes = {
  children: PropTypes.node,
};

export default Providers;
